import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import BaseUrl from '../../service/API/base_url';
import { handleError } from '../../utils/toast';

//login users
export const loginUser = createAsyncThunk(
  'userLogin',
  async (authData, thunkAPI) => {
    try {
      let baseUrl = `${BaseUrl}dorm-api/users/login`;
      // response
      let response = await axios.post(baseUrl, authData);
      // condition
      if (response.status === 200 && response.data.token) {
        localStorage.setItem('userInfo', JSON.stringify(response.data));
        return response.data;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError(e.response.data.message);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

//Get single user
export const singleUser = createAsyncThunk(
  'userLogin',
  async (id, thunkAPI) => {
    try {
      let response = await axios.get(`${BaseUrl}dorm-api/users/${id}`);

      if (response.status === 200) {
        return response.data;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError('loading...');
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

//send email and get otp for password forgot
export const sendEmail = createAsyncThunk(
  'userLogin',
  async (emailData, thunkAPI) => {
    try {
      let baseUrl = `${BaseUrl}dorm-api/forgot-password`;
      // response
      let response = await axios.post(baseUrl, emailData);
      // condition
      if (response.status === 200) {
        return response.data;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError(e.response.data.message);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

//send gmail otp to this server and validate it
export const otpValidate = createAsyncThunk(
  'userLogin',
  async (otpData, thunkAPI) => {
    try {
      let baseUrl = `${BaseUrl}dorm-api/validate-otp`;
      // response
      let response = await axios.post(baseUrl, otpData);

      // condition
      if (response.status === 200) {
        return response.data;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError(e.response.data.message);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

//reset password
export const resetPassword = createAsyncThunk(
  'userLogin',
  async (passwordData, thunkAPI) => {
    try {
      let baseUrl = `${BaseUrl}dorm-api/reset-password`;
      // response
      let response = await axios.post(baseUrl, passwordData);
      // condition
      if (response.status === 200) {
        return response.data;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError(e.response.data.message);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
